<template>
  <div>
    <p>
      {{ itemTypeString }}
      <a :href="getUrl()"><span v-html="notificationData.name"></span></a>
      <span v-if="notificationData.updated"> {{ $t('was updated') }}</span>
      <span v-else-if="notificationData.created"> {{ $t('was created') }}</span>
      <span v-else-if="notificationData.deleted"> {{ $t('was deleted') }}</span>
      <span v-else-if="notificationData.restored"> {{ $t('was restored') }}</span>
      <span v-else> {{ $t('was viewed') }}</span>
    </p>
  </div>
</template>

<script>
import BaseComponent from '@/components/commentsNew/BaseComponent'

export default {
  name: 'curriculumViewNotification',
  extends: BaseComponent,
  props: {
    notificationData: {
      type: Object,
      required: true
    },
    itemTypeString: {
      type: String,
      required: true
    },
    itemType: {
      type: String,
      required: true
    }
  },
  methods: {
    getUrl () {
      if (this.itemType === 'Unit') {
        return '/develop/unit-planner/' + this.notificationData.id + '?yearId=' + this.notificationData.yearId
      } else if (this.itemType === 'UnitCalendar') {
        return `/develop/course-map/${this.notificationData.mapId}/unit-calendar/year?yearId=${this.notificationData.yearId}`
      } else if (this.itemType === 'CourseDescription') {
        return '/Atlas/Develop/View/CourseDescription?CurriculumMapID=' + this.notificationData.mapId + '&YearID=' + this.notificationData.yearId
      }
      return '/Atlas/Browse/View/Map?CurriculumMapID=' + this.notificationData.mapId + '&YearID=' + this.notificationData.yearId
    }
  }
}
</script>
